export const replaceSingleH1TagWithH2Tag = (html, h1InnerHTML) => {
  const toReplace = `<h1([^>]*)>${h1InnerHTML}</h1>`;
  const regex = new RegExp(toReplace);
  return html.replace(regex, (_match, h1Attributes) => {
    return `<h2${h1Attributes}>${h1InnerHTML}</h2>`;
  });
};